import * as React from 'react';
import frLocale from 'date-fns/locale/fr';
import ruLocale from 'date-fns/locale/ru';
import deLocale from 'date-fns/locale/de';
import enLocale from 'date-fns/locale/en-US';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import DatePicker from '@mui/lab/DatePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { areDayPropsEqual } from '@mui/lab/PickersDay/PickersDay';
import { Box, Button, Grid, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AppNewsUpdate } from './_dashboard/app';
import LangContext from './common/LangContext';
const localeMap = {
  en: enLocale,
  fr: frLocale,
  ru: ruLocale,
  de: deLocale,
};

const maskMap = {
  fr: '__/__/____',
  en: '__/__/____',
  ru: '__.__.____',
  de: '__.__.____',
};

export function GetFilterData (from, to) {

    var date = new Date();

    if (from === undefined || to === undefined){
      from = new Date();
      to = new Date();
      from.setMonth(from.getMonth() - 1);
    }
 
    var finalFrom = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    finalFrom.setHours(0);
    finalFrom.setMinutes(0);
    finalFrom.setSeconds(0);

    var finalTo = new Date(to.getFullYear(), to.getMonth(), to.getDate());
    finalTo.setHours(23);
    finalTo.setMinutes(59);
    finalTo.setSeconds(59);


    var o = {
        from : finalFrom,
        fromOffset : finalFrom.getTimezoneOffset(),
        to : finalTo,
        toOffset : finalTo.getTimezoneOffset(),
        desiredOffset : new Date().getTimezoneOffset(),
        isValid : finalFrom instanceof Date && isFinite(finalFrom) && finalTo instanceof Date && isFinite(finalTo)
    };    

    // console.log(o);

    return o;
}
export default function Filter(props) {

  const {t, i18n} = useTranslation();
  const { lang } = React.useContext(LangContext);
  // var lang = i18n.language;
  
  
  // if (lang === undefined){
  //   lang = "en";
  // }
  // else{
  //   lang = i18n.language.substring(0,2);
  // }

  // lang = "de";
  const [from, setFrom] = React.useState(props.data.from);
  const [to, setTo] = React.useState(props.data.to);

  const [dateRangeQuickSelect, setDateRangeQuickSelect] = React.useState('1month');

  const dateRangeQuickSelectChange = (event, value) => {
   
    var from = new Date();
    var to = new Date();

    if (value == "today"){
      
    }
    else if (value == "3days"){
      from.setDate(from.getDate() - 3);
    }
    else if (value == "7days"){
      from.setDate(from.getDate() - 7);
    }
    else if (value == "1month"){
      from.setMonth(from.getMonth() - 1);
    }
    else if (value == "1year"){
      from.setMonth(from.getMonth() - 12);
    }


    setDateRangeQuickSelect(value);
    setFrom (from);
    setTo(to);

    callback(from, to);
  };



  

  console.log("FIlter renders");

  const callback = (from, to)=>{
    props.setData(GetFilterData(from, to));  
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={localeMap[lang]}>
      
 
        {/* <ToggleButtonGroup value={locale} exclusive sx={{ mb: 2, display: 'block' }}>
          {Object.keys(localeMap).map((localeItem) => (
            <ToggleButton
              key={localeItem}
              value={localeItem}
              onClick={() => selectLocale(localeItem)}
            >
              {localeItem}
            </ToggleButton>
          ))}
        </ToggleButtonGroup> */}

      <Stack  className="dashboard_filter"
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              flexWrap="wrap"
              >
        <ToggleButtonGroup
              sx={{ m: 0.5 }}
              color="primary"
              value={dateRangeQuickSelect}
              exclusive
              onChange={dateRangeQuickSelectChange}
            >
          <ToggleButton value="today">{t("today")}</ToggleButton>
          <ToggleButton value="3days">{t("3days")}</ToggleButton>
          <ToggleButton value="7days">{t("7days")}</ToggleButton>
          <ToggleButton value="1month">{t("1month")}</ToggleButton>
          <ToggleButton value="1year">{t("1year")}</ToggleButton>
       
        </ToggleButtonGroup>


  


        <div  className="datePickerContainer">
          <DatePicker
            className="datePicker"
            label={t("from")}
            maxDate={to}
            mask={maskMap[lang]}
            value={from}
            onChange={(newValue) => { setFrom(newValue); setDateRangeQuickSelect(null); callback(newValue, to); } }
            renderInput={(params) => <TextField {...params} />}
          />
          {/* </div>
        <div  className="datePickerContainer"> */}
          <DatePicker
            className="datePicker"
            label={t("to")}
            minDate={from}
            maxDate={new Date()}
            mask={maskMap[lang]}
            value={to}
            onChange={(newValue) => {  setTo(newValue); setDateRangeQuickSelect(null); callback(from, newValue); }}
            renderInput={(params) => <TextField {...params} />}
          />
        </div>
        </Stack>
 
    </LocalizationProvider>
  );
}